import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { languages } from 'config/constants';
import { resources } from './languages';

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    resources,
    defaultNS: ['translation'],
    lng: languages.pt_BR,
    fallbackLng: languages.pt_BR,
    interpolation: {
      escapeValue: false,
    },
  });

export { i18n };
